export const APP_HEADER_HEIGHT = '68px'
export const APP_SIDEBAR_WIDTH = '64px'
